import { useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
export const AuthorizedRoute = ({ element, requiredPermissions }) => {
	const { permissions } = useSelector((state) => state.user);
	const { instance } = useMsal();
	// !!! don't use useIsAuthenticated, because it will cause a bug
	// it will always return false first time when page refreshed
	if (instance.getActiveAccount() == null) {
		return <Navigate to="/login" />;
	}

	if (requiredPermissions && requiredPermissions.length > 0) {
		const isPermitted = requiredPermissions.some((permission) => permissions.includes(permission));
		return isPermitted ? element : <Navigate to="/404" replace />;
	}
	return element;
};
